import api from "./server";

export const requestCallbackService = async (body) => {
  try {
    const { data } = await api.post(`/common_publish/commonPublish`, body);

    return data;
  } catch (error) {
    throw error;
  }
};

export const fetchApplicationsService = async ({ user_id }) => {
  try {
    const { data } = await api.get(`/applications`, {
      user_id,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const fetchStudentAttendanceService = async ({ category, attendanceType }) => {
  try {
    const { data } = await api.get(
      `/applications/get-attendance?category=${category}&attendanceType=${attendanceType}`
    );

    return data;
  } catch (error) {
    throw error;
  }
};


export const fetchStudentAttendanceStatusService = async ({ batch_id, category, program_id }) => {
  try {
    const { data } = await api.post(
      `/applications/get-user-attendance-status?batch_id=${batch_id}&category=${category}&program_id=${program_id}`
    );

    return data;
  } catch (error) {
    throw error;
  }
};

export const fetchDasboardStatusService = async ({ enrol_id }) => {
  try {
    const { data } = await api.post(
      `/applications/get-dashboard-status`, { enrol_id }
    );

    return data;
  } catch (error) {
    throw error;
  }
};


export const fetchAcknowledgmentStatusService = async () => {
  try {
    const { data } = await api.get(`/students/acknowledgment-status`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateAcknowledgmentStatusService = async ({
  security_status,
}) => {
  try {
    const { data } = await api.post(`/students/acknowledgment-status`, {
      security_status,
    });

    return data;
  } catch (error) {
    throw error;
  }
};


export const fetchUserFeedbackCount = async ({ userId }) => {
  try {
    const { data } = await api.post(`/students/fetch-student-feedback-count`, {
      userId,
    });
    return data;
  } catch (error) {
    throw error;
  }
};


export const updateUserFeedbackCountServices = async ({
  userId,
}) => {
  try {
    const { data } = await api.post(`/students/update-student-feedback-count`, {
      userId,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const updateUserFeedbackStatusServices = async ({
  userId,
}) => {
  try {
    const { data } = await api.post(`/students/update-feedback-status`, {
      userId,
    });

    return data;
  } catch (error) {
    throw error;
  }
};

export const getInclusionStatusService = async ({ user_id, program_id }) => {
  try {
    const { data } = await api.post(`/students/get-inclusion-status`, {
      user_id,
      program_id,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateInclusionStatusService = async ({
  user_id,
  program_id,
  inclusion_skip_count,
  inclusion_acceptance_status,
}) => {
  try {
    const { data } = await api.post(`/students/update-inclusion-status`, {
      user_id,
      program_id,
      inclusion_skip_count,
      inclusion_acceptance_status,
    });
    return data;
  } catch (error) {
    throw error;
  }
};


export const getExternalInclusionVerificationStatusService = async ({ enrol_id, program_id }) => {
  try {
    const { data } = await api.post(`/students/get-external-inclusion-verification-status`, {
      enrol_id,
      program_id,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const downloadInclusionDocService = async (body) => {
  try {
    const { data } = await api.post(`/students/download-inclusion-doc`, body);
    return data;
  } catch (error) {
    throw error;
  }
};

export const uploadSignedInclusionDocService = async (formData) => {
  try {
    const { data } = await api.post(`/students/upload-signed-inclusion-doc`, formData);
    return data;
  } catch (error) {
    throw error;
  }
};

export const getDashboardTourStatusService = async () => {
  try {
    const userId = localStorage.getItem("user_id");
    const { data } = await api.get(`/students/get-dashboard-tour-status`, {
      params: { user_id: userId },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateDashboardTourStatusService = async ({ step_index, status }) => {
  try {
    const userId = localStorage.getItem("user_id");
    const { data } = await api.post(`/students/update-dashboard-tour-status`, {
      user_id: userId,
      step_index,
      status,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const resetDashboardTourService = async () => {
  try {
    const userId = localStorage.getItem("user_id");
    const { data } = await api.post(`/students/reset-dashboard-tour`, {
      user_id: userId,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const fetchInstallmentPlanService = async ({ enrol_id }) => {
  try {
    const { data } = await api.post(`/students/get-installment-plan`, {
      enrol_id,
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const uploadInstallmentAgreementService = async (formData) => {
  try {
    const { data } = await api.post(`/students/upload-installment-agreement`, formData);
    return data;
  } catch (error) {
    throw error;
  }
};
